import { useEffect, useState } from 'react'
import axios from 'axios'
import { useTheme } from '@table-library/react-table-library/theme'
import {
  DEFAULT_OPTIONS,
  getTheme,
} from '@table-library/react-table-library/material-ui'
import { Stack, TextField } from '@mui/material'
import { usePagination } from '@table-library/react-table-library/pagination'

import { TABLE_THEME, SERVER_URL } from '../../../constants'
import Button from '../../../components/Button'
import ManageTable from './ManageTable'

function ManageExcess() {
  const [isLoading, setIsLoading] = useState(false)

  const [fromInput, setFromInput] = useState('2022-10-01')

  const [storedData, setStoredData] = useState({ nodes: [] })
  const [displayedData, setDisplayedData] = useState({ nodes: [] })

  useEffect(() => {
    renderTable()
  }, [])

  const columns = [
    { label: 'Name', renderCell: (item) => item.ingredient },
    {
      label: 'Percent Sold',
      renderCell: (item) => Math.round(item.percent * 100) / 100,
    },
  ]

  const materialTheme = getTheme(DEFAULT_OPTIONS)
  const COLUMN_THEME = {
    Table: `
      --data-table-library_grid-template-columns: 67% 33%;
    `,
  }
  const theme = useTheme([materialTheme, TABLE_THEME, COLUMN_THEME])

  const pagination = usePagination(displayedData, {
    state: {
      page: 0,
      size: 5,
    },
  })

  async function renderTable() {
    setIsLoading(true)

    let excessRes = await axios.get(
      `${SERVER_URL}/ingredients/excess/${fromInput}`,
    )

    if (excessRes) {
      setDisplayedData({ nodes: excessRes.data })
      setStoredData({ nodes: excessRes.data })
    }

    setIsLoading(false)
  }

  return (
    <>
      <ManageTable
        searchProps={{
          name: 'Ingredients',
          property: 'ingredient',
          data: storedData,
          setData: setDisplayedData,
        }}
        columns={columns}
        displayedData={displayedData}
        theme={theme}
        pagination={pagination}
      />

      <Stack direction="row" spacing={2}>
        <TextField
          id="from-field"
          label="From"
          fullWidth
          placeholder={'YYYY-MM-DD'}
          InputLabelProps={{ shrink: true }}
          onChange={(event) =>
            event.target.value
              ? setFromInput(event.target.value)
              : setFromInput('2022-10-01')
          }
        />

        <Button
          size="lg"
          fullWidth
          isLoading={isLoading}
          onClick={() => renderTable()}
        >
          Render Table
        </Button>
      </Stack>
    </>
  )
}

export default ManageExcess
